import { render, staticRenderFns } from "./WPCollapseContent.vue?vue&type=template&id=a453ed8c&scoped=true&"
import script from "./WPCollapseContent.vue?vue&type=script&lang=js&"
export * from "./WPCollapseContent.vue?vue&type=script&lang=js&"
import style0 from "./WPCollapseContent.vue?vue&type=style&index=0&id=a453ed8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a453ed8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a453ed8c')) {
      api.createRecord('a453ed8c', component.options)
    } else {
      api.reload('a453ed8c', component.options)
    }
    module.hot.accept("./WPCollapseContent.vue?vue&type=template&id=a453ed8c&scoped=true&", function () {
      api.rerender('a453ed8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WPCollapseContent.vue"
export default component.exports